import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { Loader2, X } from 'lucide-angular';

import { ModalShellComponent } from '@infrastructure/ui/components/modals/modal-shell/modal-shell.component';
import { ConfirmacaoSimNaoComponent } from '@infrastructure/ui/components/modals/confirmacao-sim-nao/confirmacao-sim-nao.component';
import { TabsComponent } from '@infrastructure/ui/components/tabs/tabs.component';
import { TabPanelComponent } from '@infrastructure/ui/components/tabs/tab-panel.component';
import { FormFooterComponent } from '@infrastructure/ui/components/forms/form-footer/form-footer.component';
import { PrototypeSelectComponent } from '@infrastructure/ui/components/forms/prototype-select/prototype-select.component';
import { PeriodoSelectComponent } from '@infrastructure/ui/components/forms/periodo-select/periodo-select.component';
import { AnexosComponent } from '@infrastructure/ui/components/anexos/anexos.component';
import { DatepickerComponent } from '@infrastructure/ui/components/forms/datepicker/datepicker.component';
import { UtilsComponentesModule } from '../../../utils/componentes/utils-componentes.module';
import { InstrumentoAvaliacaoModalComponent } from './instrumento-avaliacao-modal.component';
import { InstrumentoExclusaoConfirmacaoModalComponent } from './instrumento-exclusao-confirmacao-modal.component';

@NgModule({
  declarations: [
    InstrumentoAvaliacaoModalComponent,
    InstrumentoExclusaoConfirmacaoModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalShellComponent,
    ConfirmacaoSimNaoComponent,
    TabsComponent,
    TabPanelComponent,
    FormFooterComponent,
    PrototypeSelectComponent,
    PeriodoSelectComponent,
    AnexosComponent,
    DatepickerComponent,
    UtilsComponentesModule,
    LucideAngularModule.pick({
      Loader2,
      X
    })
  ],
  exports: [InstrumentoAvaliacaoModalComponent]
})
export class InstrumentoAvaliacaoModalModule {}
